var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_48195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.892 5.85671L14.1835 19.8872C14.0557 20.1855 13.835 20.3695 13.5213 20.4393C13.2077 20.5091 12.9348 20.428 12.7027 20.1959L4.36707 11.8603C4.13498 11.6282 4.05385 11.3553 4.12366 11.0417C4.19346 10.728 4.37749 10.5073 4.67574 10.3795L18.7063 4.67096C19.0852 4.52411 19.4143 4.59029 19.6935 4.8695C19.9727 5.14871 20.0389 5.47778 19.892 5.85671ZM13.1311 18.503L17.9747 6.58824L6.05999 11.4319L8.67085 14.0428L13.4302 11.1328L10.5202 15.8921L13.1311 18.503Z",
    fill: "#292B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_48195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.0629883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.fedbd138743f7a959f558d8b7fba0380.svg";
export { ForwardRef as ReactComponent };